import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
`;
export const Headerpart = styled.div`
	display: grid;
	grid-template-columns: 1fr 170px;
	-webkit-box-pack: start;
	justify-content: flex-start;
	-webkit-box-align: center;
	align-items: center;
	gap: 0.4rem;
	padding: 0.2rem 0px;
`;

export const HeaderTitle = styled.h5`
	color: ${({ theme }) => theme.pantone2726C};
	font-size: 1rem;
	font-weight: bold;
`;
export const AreaSelectAll = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;

	.MuiFormControlLabel-root {
		margin: 0 0.3rem 0 0;
	}
`;
export const RowPart = styled.div`
	display: grid;
	grid-template-columns: 100px minmax(45%, 1fr) 50px;
	justify-content: flex-start;
	align-items: center;
	gap: 0.4rem;
	padding: 0.2rem 0;
	border-bottom: 1px solid ${({ theme }) => theme.grayDark};
	cursor: pointer;
	transition: background-color 0.3s;

	&:hover {
		background-color: ${({ theme }) => theme.grayLight};
	}
`;
export const ImagePart = styled.img`
	width: 100%;
	max-width: 100px;
	height: 80px;
	object-fit: contain;
`;

export const AreaTitlePart = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3px;

	&&& {
		> div:first-child {
			padding-left: 6px;
		}
		.MuiFormControl-root {
			border-radius: 4px;
		}

		.MuiInputBase-root {
			border: 1px solid ${({ theme }) => theme.grayDark};
			padding-top: 0px;
			padding-bottom: 0px;
			padding-left: 2px;
		}
	}
`;
